import { HttpClient } from "@/app/api/HttpClient"
import { API_PREFIX_EVENT_SUBSCRIBERS_PATH } from "@/constants/prefix-path-api"
import { t } from "@/languages/i18n"
// IMPORT TẤT CẢ INTERFACE TỪ FILE TYPE CHUNG ĐỂ ĐỒNG BỘ
import { message } from "@/lib/config/lib/antd-global"
import { EventSubscriberPayload, FilterSearchParams } from "@/types/types"

/**
 * FETCH DANH SÁCH EVENT SUBSCRIBERS VỚI PHÂN TRANG VÀ BỘ LỌC
 */
export const fetchEventSubscribers = async (searchTerms: { [key: string]: string } = {}) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    filters: {},
    pagination: {
      withCount: true,
    },
  }

  if (searchTerms.publicationState === "draft") {
    params.publicationState = "preview"
  } else {
    params.publicationState = searchTerms.publicationState || "preview"
  }

  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page", "sort", "fields", "populate"]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "sort") {
      params.sort = value
    } else if (key === "fields") {
      // @ts-ignore
      params.fields = value
    } else if (key === "populate") {
      params.populate = value
    } else if (key === "locale") {
      params.locale = value
    } else if (!excludedKeys.includes(key)) {
      if (value) {
        params.filters[key] = { $containsi: value }
      }
    } else if (value && key !== "publicationState") {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })

  // Set default pageSize if not provided
  if (!params.pagination) {
    params.pagination = { withCount: true }
  }
  if (!params.pagination.pageSize) {
    params.pagination.pageSize = 20
  }

  try {
    const response = await HttpClient.get(`${API_PREFIX_EVENT_SUBSCRIBERS_PATH}`, { params,skipDomainFilter:true })
    return {
      data: response.data,
      meta: response.meta,
    }
  } catch (error) {
    message.error(t("Lỗi khi tải danh sách đối tác sự kiện. Vui lòng thử lại."))
    throw error
  }
}

/**
 * LẤY CHI TIẾT MỘT SUBSCRIBER THEO ID
 */
export const fetchEventSubscriberId = async (id: number | string) => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_EVENT_SUBSCRIBERS_PATH}/${id}?populate=*`,{skipDomainFilter:true})
    return response.data
  } catch (error) {
    message.error(t("Lỗi khi tải thông tin đối tác sự kiện. Vui lòng thử lại."))
    throw error
  }
}

/**
 * XÓA SUBSCRIBER
 */
export const deleteEventSubscriber = async (id: number | string) => {
  try {
    return await HttpClient.delete(`${API_PREFIX_EVENT_SUBSCRIBERS_PATH}/${id}`,{skipDomainFilter:true})
  } catch (error) {
    message.error(t("Lỗi khi xóa đối tác sự kiện. Vui lòng thử lại."))
    throw error
  }
}

/**
 * CẬP NHẬT THÔNG TIN SUBSCRIBER (SỬ DỤNG INTERFACE TỪ TYPE.TS)
 */
export const updateEventSubscriber = async (id: number | string, data: EventSubscriberPayload) => {
  try {
    return await HttpClient.put(`${API_PREFIX_EVENT_SUBSCRIBERS_PATH}/${id}`, data,{skipDomainFilter:true})
  } catch (error) {
    message.error(t("Lỗi khi cập nhật đối tác sự kiện. Vui lòng thử lại."))
    throw error
  }
}

/**
 * THÊM MỚI SUBSCRIBER (SỬ DỤNG INTERFACE TỪ TYPE.TS)
 */
export const addEventSubscriber = async (data: EventSubscriberPayload) => {
  try {
    return await HttpClient.post(`${API_PREFIX_EVENT_SUBSCRIBERS_PATH}`, data,{skipDomainFilter:true})
  } catch (error) {
    message.error(t("Lỗi khi thêm đối tác sự kiện. Vui lòng thử lại."))
    throw error
  }
}
